import branchesData from './shared/state';

export default {
  modules: {
    branchesData,
  },
};
